import { useContext, useEffect } from 'react';
import './style.scss';
import { FormDataContext } from '../FormDataProvider';

function PersonalInfoStep() {

  const { updateFormData, updateMultiSelectData, updateSingleSelectData } = useContext(FormDataContext);

  return (
    <div className="personal-info-step">
      <h2>Personlig information</h2>
        <form>
            <label>
                Förnamn
                <input type="text" name="firstname" placeholder="Förnamn" onChange={(e) => updateFormData(e)} required />
            </label>
            <label>
                Efternamn
                <input type="text" name="lastname" placeholder="Efternamn" onChange={(e) => updateFormData(e)} required />
            </label>
            <label className="full">
                Personnummer (ÅÅMMDD-XXXX)
                <input type="text" name="personalnumber" placeholder="Personnummer" onChange={(e) => updateFormData(e)} required />
            </label>
            <label className="full" single-select="true" name="gender" onClick={(e) => updateSingleSelectData(e)} required>
                <div className="label-description">Jag identifierar mig som</div>
                <div className="multi-select">
                  <div className="multi-select-item">
                    <label>
                      <input type="radio" name="gender" value="woman" /><span>Kvinna</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="radio" name="gender" value="man" /><span>Man</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="radio" name="gender" value="other" /><span>Annat</span>
                    </label>
                  </div>
                </div>
            </label>
            <label className="full" multi-select="true" name="profession" onClick={(e) => updateMultiSelectData(e)} required>
                <div className="label-description">Inriktning</div>
                <div className="multi-select">
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" name="illustrator" value="illustrator" /><span>Illustratör</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" id="graphic_designer" value="graphic_designer" /><span>Grafisk Formgivare</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" id="animator" value="animator" /><span>Animatör</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" id="comic" value="comic" /><span>Serietecknare</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" id="digital_designer" value="digital_designer" /><span>Digital Designer</span>
                    </label>
                  </div>
                  <div className="multi-select-item">
                    <label>
                      <input type="checkbox" id="other" value="other" /><span>Annat</span>
                    </label>
                  </div>
                </div>
            </label>
        </form>
    </div>
  );
}

export default PersonalInfoStep;
